import { render, staticRenderFns } from "./tabIcon.vue?vue&type=template&id=2db2c96e&scoped=true&"
import script from "./tabIcon.vue?vue&type=script&lang=js&"
export * from "./tabIcon.vue?vue&type=script&lang=js&"
import style0 from "./tabIcon.vue?vue&type=style&index=0&id=2db2c96e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2c96e",
  null
  
)

export default component.exports